import { WithPromiseFunctions } from '@wix/editor-platform-transport';
import type { PlatformWorkerAPI } from '@wix/editor-platform-environment-api';
import { PlatformWorkerStrategy } from './PlatformWorkerStrategy';
import { LimitedPrivateAPI } from '@wix/editor-platform-private-api';
import { PlatformPrivateEventEmitter } from '@wix/public-editor-platform-events';

const createDeduplicateScope = () => {
  let promise: Promise<unknown> | null = null;

  return async <T>(fn: () => Promise<T>) => {
    if (!promise) {
      promise = fn();
    }

    return promise as Promise<T>;
  };
};

export class SingleWorkerStrategy extends PlatformWorkerStrategy {
  private workerAPI: WithPromiseFunctions<PlatformWorkerAPI> | undefined =
    undefined;

  private spawnWorkerDeduplicator = createDeduplicateScope();

  constructor(
    private getWorkerUrl: () => Promise<string>,
    protected limitedPrivateAPI: LimitedPrivateAPI,
    protected events: PlatformPrivateEventEmitter,
  ) {
    super(limitedPrivateAPI, events);
  }

  async getWorkerAPI(): Promise<WithPromiseFunctions<PlatformWorkerAPI>> {
    if (this.workerAPI) {
      return this.workerAPI;
    }

    const workerUrl = await this.getWorkerUrl();
    const workerAPI = await this.spawnWorkerDeduplicator(() =>
      this.spawnWorker(workerUrl),
    );

    this.workerAPI = workerAPI;

    return workerAPI;
  }

  forEachWorker(
    cb: (workerAPI: WithPromiseFunctions<PlatformWorkerAPI>) => void,
  ) {
    if (this.workerAPI) {
      cb(this.workerAPI);
    }
  }
}
